import { BElement } from "utils/base-component"

export class DesktopDropdowns {
  private cssClass: string
  private favouritesBtn?: BElement
  private favouritesDropdown?: BElement
  private arrowIcon?: BElement

  constructor(cssClass: string) {
    this.cssClass = cssClass
    this.initializeElements()
    this.initializeDropdownStates()
    this.addEventListeners()
  }

  private initializeElements() {
    const getElement = (selector: string) => {
      const element = document.querySelector(selector)
      return element ? new BElement(element, this.cssClass) : undefined
    }

    this.favouritesBtn = getElement("#favourites")
    this.favouritesDropdown = getElement(".account-favourites-dropdown")
    this.arrowIcon = getElement(".page-header__favourites-arrow-icon")
  }

  private initializeDropdownStates() {
    // Set initial dropdown state - hidden by default
    this.favouritesBtn?.element.setAttribute("aria-expanded", "false")
    this.favouritesDropdown?.element.classList.remove("active")
  }

  private addEventListeners() {
    this.favouritesBtn?.element.addEventListener("click", (e) => {
      e.preventDefault()
      e.stopPropagation()
      this.toggleDropdown()
    })
  }

  private toggleDropdown(): void {
    if (
      !this.favouritesDropdown?.element ||
      !this.favouritesBtn?.element ||
      !this.arrowIcon?.element
    )
      return

    const dropdownElement = this.favouritesDropdown.element
    const buttonElement = this.favouritesBtn.element
    const arrowIconElement = this.arrowIcon.element
    const isExpanded = buttonElement.getAttribute("aria-expanded") === "true"

    // Toggle dropdown state
    if (isExpanded) {
      dropdownElement.classList.remove("active")
      buttonElement.setAttribute("aria-expanded", "false")
      buttonElement.classList.remove("active")
      arrowIconElement.classList.remove("active")
    } else {
      dropdownElement.classList.add("active")
      buttonElement.setAttribute("aria-expanded", "true")
      buttonElement.classList.add("active")
      arrowIconElement.classList.add("active")
    }
  }

  // Public method to check if click is inside favourites dropdown
  isFavouritesDropdownClick(target: Node): boolean {
    return !!(this.favouritesDropdown?.element && this.favouritesDropdown.element.contains(target))
  }

  // Public method to check if click is on favourites button
  isFavouritesButtonClick(target: Node): boolean {
    return !!(this.favouritesBtn?.element && this.favouritesBtn.element.contains(target))
  }

  // Public method to close favourites dropdown
  closeFavouritesDropdown(): void {
    if (
      this.favouritesDropdown?.element &&
      this.favouritesBtn?.element &&
      this.arrowIcon?.element
    ) {
      this.favouritesDropdown.element.classList.remove("active")
      this.favouritesBtn.element.setAttribute("aria-expanded", "false")
      this.favouritesBtn.element.classList.remove("active")
      this.arrowIcon.element.classList.remove("active")
    }
  }

  // Public method to check if favourites dropdown is currently open
  hasOpenFavouritesDropdown(): boolean {
    return !!(
      this.favouritesDropdown?.element &&
      this.favouritesDropdown.element.classList.contains("active")
    )
  }
}
